import PropTypes from 'prop-types';
import React from 'react';


const ShareIcon = ({children, link}) => <a
    href={link}
    className={'share-icon'}
    rel={'noreferrer'}
    target={'_blank'}
>
    {children}
</a>;

ShareIcon.propTypes = { children: PropTypes.node,
    link: PropTypes.string };

export default ShareIcon;